import Modal from "./modal";
import MedicalSpeciality from "../medicalSpeciality";
import {useState} from "react";
import { useDispatch } from "react-redux";
import { editPost } from "../action";
import { setResetDropdown } from "../slice";

export default (props) => {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch()

    const edit = (event) => {
        event.preventDefault();
        // dispatch(editPost())
        dispatch(setResetDropdown(false))

        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };
    return (
        <div className="card h-100">
        {
            showModal && <Modal label={"Medical Specialties"} showHide={edit} saveFunction={save}>
                <MedicalSpeciality errors={props.errors}/>
            </Modal>
        }
        <div className="card-header">
                    <b><h5 className="mb-0">Medical Specialties</h5></b>
                    {
                        props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                            <i className="fe fe-edit" title="Edit Medical Specialties"></i>
                        </a>
                    }
        </div>
        <div className="card-body">
            <div className="form-group">
                <>
                    <div className="row">
                        {props?.employerJobSpecialtyList?.length > 0 ? (
                        <div className="col-lg-12 col-md-12">
                        <label className="form-label">
                            Choose specialty for this Shift?
                        </label>
                        {props?.employerJobSpecialtyList.map((item) => (
                            <div>
                            <label>{item.name}</label>
                            </div>
                        ))}
                        </div>
                    ) : null}
                        {/* <div className="col-lg-4 col-md-6">
                            <label className="form-label">Year of Experiance</label>
                            {
                                props?.employerJobSpecialtyList.map(item => (
                                    <div><label>{item.yearsOfExperience}</label></div>
                                ))
                            }
                        </div> */}
                        {/* <div className="col-lg-2 col-md-6">
                            <label className="form-label">Mandatory</label>
                            {
                                props?.employerJobSpecialtyList.map(item => (
                                    <div><label>{item.mandatory ? 'Yes' : 'No'}</label></div>
                                ))
                            }
                        </div> */}
                    </div>
                </>
            </div>
        </div>
    </div>
    )
}
